import FilterUtils from '@/shared/utils/filters';
import RangeParameterScriptRequest from './range-parameter-script-request';

export default class ContractParametersRequest {
  parameterId: string;

  value: any;

  constructor(obj: any = {}) {
    this.parameterId = obj.id || '';
    this.handleValue(obj);
  }

  public static of(obj: any = {}): ContractParametersRequest {
    return new ContractParametersRequest(obj || {});
  }

  public static ofList(obj: any[]): ContractParametersRequest[] {
    return obj.map(this.of);
  }

  handleValue(obj) {
    if (obj.type.value === 'RANGE' || obj.type.value === 'RANGE2'
      || obj.type.value === 'RANGE_PERCENT' || obj.type.value === 'RANGE_PERCENT2') {
      this.value = obj.value.map(RangeParameterScriptRequest.of);
    }
    if (obj.type.value === 'MONEY' || obj.type.value === 'MONEY2'
      || obj.type.value === 'PERCENT' || obj.type.value === 'PERCENT2') {
      this.value = parseFloat(FilterUtils.formatValue(obj.value));
    }
    if (obj.type.value === 'LONG') {
      this.value = parseInt(obj.value, 10);
    }
    if (obj.type.value === 'KEY_VALUE' || obj.type.value === 'KEY_VALUE_PERCENT') {
      this.value = this.convertToObject(obj.value);
    }
    if (obj.type.value === 'STRING_LIST') {
      this.value = obj.value;
    }
    if (obj.type.value === 'BOOLEAN') {
      this.value = obj.value;
    }
    if (obj.type.value === 'CURRENCY_CONVERT') {
      this.value = obj.value;
    }
  }

  convertToObject(value) {
    const dataObject = Object()
    value.forEach((el: any) => {
      dataObject[el.field] = parseFloat(FilterUtils.formatValue(el.value))
    })
    return dataObject;
  }
}
